module.exports = __webpack_public_path__ + "media/packs/images/partners/partner6-79989f485f18fbee6683828cd091f609.jpg";